import React from 'react'
import { useState } from 'react'
import MessFoodLogs from './MessFoodLogs'
import OtherFoodLogs from './OtherFoodLogs'

function FoodLogs() {
    const [type, setType] = useState(true)

    const toggleType = ()=>{
        setType(!type)
    }

    return (
        <>
            <div className='mb-3 row'>
                <div style={{width:"fit-content"}}>
                    <button className={`${type ? "btn btn-primary active" : "btn btn-light "}`} onClick={toggleType}>Mess Logs</button>
                </div>
                <div style={{width:"fit-content"}}>
                    <button className={`${!type ? "btn btn-primary active" : "btn btn-light "}`} onClick={toggleType}>Other Logs</button>
                </div>
            </div>
            {type ? <MessFoodLogs></MessFoodLogs> : <OtherFoodLogs></OtherFoodLogs>}
        </>
    )
}

export default FoodLogs